// src/components/ProductCarousel/ProductCarousel.js
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PDFFlipbook from '../PDFFlipbook/PDFFlipbook';
import Carousel from '../Common/Carousel/Carousel';
import { getCategories } from '../../api/productrangeService';
import './ProductCarousel.css';
import PageBanner from '../Common/PageBanner';

const ProductCarousel = () => {

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState('');
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [selectedCatalog, setSelectedCatalog] = useState('');
    const [catalogSize, setCatalogSize] = useState('');
    const [pageNo, setPageNo] = useState(1);
    const [hasMore, setHasMore] = useState(true);


    const fetchCategories = useCallback(async (page = 1, isLoadMore = false) => {
        try {
            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setLoading(true);
            }

            const params = {
                pageNo: page,
                pageSize: 6
            };
            const data = await getCategories(params);
            //console.log(data);

            if (data.Data && data.Data.length > 0) {
                if (isLoadMore) {
                    setCategories(prev => [...prev, ...data.Data]);
                } else {
                    setCategories(data.Data || []);
                }

                if (data.Data.length < params.pageSize) {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (err) {
            console.error('Error fetching categories:', err);
            setError('Unable to load product categories. Please try again later.');
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    }, []);

    // Initial load
    useEffect(() => {
        fetchCategories(1, false);
    }, [fetchCategories]);

    // Load more function
    const loadMore = useCallback(() => {
        if (!loadingMore && hasMore) {
            const nextPage = pageNo + 1;
            setPageNo(nextPage);
            fetchCategories(nextPage, true);
        }
    }, [loadingMore, hasMore, pageNo, fetchCategories]);

    // Scroll handler
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                loadMore();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadMore]);

    //useEffect(() => {
    //    const fetchCategories = async () => {
    //        try {
    //            setLoading(true);
    //            const params = {
    //                pageNo: 1,
    //                pageSize: 6
    //            };
    //            const data = await getCategories(params);
    //            console.log(data)
    //            setCategories(data.Data || []);
    //        } catch (err) {
    //            console.error('Error fetching categories:', err);
    //            setError('Unable to load product categories. Please try again later.');
    //        } finally {
    //            setLoading(false);
    //        }
    //    };

    //    fetchCategories();
    //}, []);

    const handleViewCatalog = (catalog) => {
        setSelectedCatalog(catalog.Pdf);
        setCatalogSize(catalog.Size);
    };

    useEffect(() => {
        if (selectedCatalog) {
            setShowPdfModal(true);
        }
    }, [selectedCatalog])

    useEffect(() => {
        if (!showPdfModal) {
            setSelectedCatalog("");
        }
    }, [showPdfModal])

    return (
        <>
            <PageBanner
                backgroundImage="/assets/images/banner/image4.png"
                height="70vh"
                overlay={false}
            />

            {/* Main Content */}
            <section className="product-carousel-section">
                <Container className="d-flex flex-column gap-5" data-aos="fade-in">
                    <Row>
                        <Col>
                            <div className="section-header text-center">
                                <h1 className="section-product-title text-primary">
                                    Discover Our Product Range Offerings
                                </h1>
                                <h5 className="section-product-subtitle text-primary">
                                    Designed to please. Engineered to Sell.
                                </h5>
                                <p className="section-description text-primary m-0">
                                    All our jewellery is available in 9KT, 14KT, 18KT and Vermeil.
                                </p>
                            </div>
                        </Col>
                    </Row>

                    {loading ? (
                        <div className="loading-state text-center text-primary">
                            <div className="loading-spinner"></div>
                            <p>Loading categories...</p>
                        </div>
                    ) : error ? (
                        <div className="error-state text-center">
                            <p>{error}</p>
                            <button
                                className="retry-button"
                                onClick={() => fetchCategories(1, false)}
                            >
                                Retry
                            </button>
                        </div>
                    ) : (
                        categories.map((category, index) => (
                            <div key={category.Id || index} className="category-section">
                                <Row className="category-carousel">
                                    {/* Carousel Section - Left */}
                                    <Col lg={8} md={12} className="mb-lg-0 ">
                                        <Carousel
                                            items={category.Items || []}
                                        />
                                    </Col>

                                    {/* Text Content - Right */}
                                    <Col lg={4} md={12} className="d-flex flex-column align-items-center" data-aos="fade-left">
                                        <div className="category-info-carousel">
                                            <h3 className="category-title text-center text-primary">
                                                {category.Title}
                                            </h3>
                                        </div>
                                        {/* Catalog Button */}
                                        {category.Pdf && (
                                            <div className="catalog-button-container">
                                                <button
                                                    className="catalog-button"
                                                    onClick={() => handleViewCatalog(category)}
                                                >
                                                    Get Full Catalog
                                                </button>
                                                <button
                                                    className="catalog-link btn btn-link"
                                                    onClick={() => window.open(category.Pdf, '_blank')}
                                                >
                                                    Open PDF in New Tab
                                                </button>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        ))
                    )}

                    {loadingMore && <div>Loading more...</div>}
                    {!hasMore && <div>No more categories</div>}
                </Container>
            {showPdfModal}
            </section>

            {/* PDF Modal */}

            {(showPdfModal === true) &&
                <PDFFlipbook
                pdfUrl={selectedCatalog}
                catalogSize={catalogSize}
                onClose={() => setShowPdfModal(false)}
                isOpen={showPdfModal}

                />
            }                

        </>
    );
};

export default ProductCarousel;